import React, { TextareaHTMLAttributes } from 'react'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string
}

export const Textarea: React.FC<TextareaProps> = ({ className = '', ...props }) => {
  return (
    <textarea
      className={`flex-1 h-[221px] bg-pcg-borderMuted rounded-[10px] px-5 py-4 text-white resize-none outline-none font-proxima-regular ${className}`}
      {...props}
    />
  )
}